export enum RiskIndicator {
    RISKY = "risky",
    NO_RISK = "noRisk",
}
